import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { TableData } from '@dxo/ng-swift-ui/lib/components/table/components/table-base/table.types';

@Injectable({
  providedIn: 'root'
})
export class ExcelExportService {
  exportTableToXLSX(fileName: string, tableData: TableData) {
    const data = [];
    const headerRow = [];
    for (const header of tableData.headers) {
      if (typeof header === 'string') {
        headerRow.push(header);
      } else {
        headerRow.push(header.text);
      }
    }
    data.push(headerRow);

    // Store the table cells in the subsequent rows of the data array
    for (const row of tableData.cells) {
      const rowData = [];
      for (const cell of row) {
        if ('data' in cell) {
          rowData.push(cell.data);
        } else if ('display' in cell) {
          rowData.push(cell.display);
        } else {
          rowData.push(''); // Push an empty cell if neither 'data' nor 'display' is found
        }
      }
      data.push(rowData);
    }

    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    const blob: Blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    saveAs(blob, fileName);
  }
}
